import axios from 'axios';

export default {
    state: {
        headDic: null,
    },
    getters: {
        getHeadDic(state) {
            return state.headDic
        },
    },
    mutations: {
        setHeadDic(state, data) {
            return state.headDic = data
        },
    },
    actions: {
        headDicRequest(context) {
            return axios.get('/api/dictionaries/users-head')
                .then(res => {
                    context.commit('setHeadDic', res.data)
                })
        },
    }
}